import { atom } from "jotai";
import type {
  ListPanelsQuery,
  Panel,
  PanelCategory,
  PanelLicense,
  PanelModerationStatus,
} from "../types";

export const panelStatusFilterAtom = atom<PanelModerationStatus>("pending");
export const panelCategoryFilterAtom = atom<PanelCategory | "all">("all");
export const panelLicenseFilterAtom = atom<PanelLicense | "all">("all");
export const panelSearchAtom = atom<string>("");
export const panelPageAtom = atom<number>(1);

export const selectedPanelAtom = atom<Panel | null>(null);

export const panelFiltersAtom = atom<ListPanelsQuery>((get) => {
  const category = get(panelCategoryFilterAtom);
  const license = get(panelLicenseFilterAtom);
  const search = get(panelSearchAtom).trim();

  const query: ListPanelsQuery = {
    status: get(panelStatusFilterAtom),
    page: get(panelPageAtom),
    limit: 20,
  };

  if (category !== "all") query.category = category;
  if (license !== "all") query.license = license;
  if (search) query.search = search;

  return query;
});
